import React, {useRef} from 'react';
import NobulaLogoIcon from '../../../../../assets/icons/NobulaLogo.svg';
import {ImageFitEnum} from '../../../../incase-domain/common/imageFit';
import Button from '../../../../incase-domain/components/button/Button';
import AnswerComment from '../question/AnswerComment';
import {AnswerTypes} from '../question/QuestionAnswer';
import {getAnswerColors} from '../common/utils';

interface IPhotoQuestionAnswerProps {
    answer: string;
    imgSrc: string;
    answerType: AnswerTypes;
    imageFit?: ImageFitEnum;
    comment?: string;
    onClick: () => void;
    correctColor?: string;
    incorrectColor?: string;
    debatableColor?: string;
    showComment?: boolean;
    setShowComment?: (show: boolean) => void;
}

function PhotoQuestionAnswer({
    answer,
    answerType,
    comment,
    onClick,
    correctColor,
    incorrectColor,
    debatableColor,
    imgSrc,
    imageFit,
    showComment = false,
    setShowComment,
}: IPhotoQuestionAnswerProps): JSX.Element {
    const answerRef = useRef<HTMLDivElement>(null);

    const {getBtnAnswerColor, getCustomAnswerColor, getCustomAnswerColorWithAlpha} = getAnswerColors(
        answerType,
        correctColor,
        incorrectColor,
        debatableColor
    );

    return (
        <div className="c-photoAnswerQuestion__answer" ref={answerRef}>
            <div className="c-photoAnswerQuestion__answer_data" onClick={onClick}>
                <img src={imgSrc || NobulaLogoIcon} style={{objectFit: imageFit}} alt={answer} />
                <div className="c-photoAnswerQuestion__answer_selection">
                    <Button
                        variant="ghost"
                        size="2xl"
                        padded={false}
                        color={getBtnAnswerColor()}
                        customColor={getCustomAnswerColorWithAlpha(0.35)}
                        customIconColor={getCustomAnswerColor()}
                        dynamicSize
                        leading="solar:check-square-bold"
                    />
                </div>
            </div>

            {comment && <AnswerComment comment={comment} showComment={showComment} setShowComment={setShowComment} anchorRef={answerRef} />}
        </div>
    );
}

export default PhotoQuestionAnswer;
